import { compose } from "recompose";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { createStructuredSelector } from "reselect";
import { createLoadingSelector } from "core/helpers";
import { fetchApi } from "core/api/hoc";
import * as hoc from "modules/user/auth/hoc";
import { isOnboardedCandidate } from "modules/user/auth/model";
import * as bookingApi from "modules/booking/api";
import * as feedbackApi from "modules/feedback/api";
import * as bookingSelectors from "modules/booking/selectors";
import * as feedbackSelectors from "modules/feedback/selectors";
import View from "./View";

export default compose(
  hoc.authorized(isOnboardedCandidate),
  withRouter,
  fetchApi(bookingApi.getBookedCalls, {
    selector: bookingSelectors.getBookedCallsApi,
    key: "calls",
    sync: true
  }),
  connect(
    createStructuredSelector({
      call: bookingSelectors.getBookedCall,
      isLoading: createLoadingSelector(bookingSelectors.getBookedCallsApi)
    })
  ),
  fetchApi(feedbackApi.getInsiderFeedback, ({ call }) => ({
    selector: feedbackSelectors.getInsiderFeedbackApi,
    key: "selfFeedback",
    sync: true,
    payload: {
      targetId: call.insider.id,
      bookingId: call.id
    }
  })),
  fetchApi(feedbackApi.getCandidateFeedbackResult, ({ call }) => ({
    key: "feedback",
    selector: feedbackSelectors.getCandidateFeedbackResultApi,
    payload: {
      id: call.id
    }
  }))
)(View);



// WEBPACK FOOTER //
// ./src/components/pages/Candidate/DashboardCall/Provider.js